import axios from "axios";
import type { ServerError } from "./types";

/** Fallback toast title when a failed call has no structured ServerError body. */
export const DEFAULT_ERROR_TITLE = "Unable to complete the selected action";

/**
 * Extracts the structured `{ call, message }` payload the backend returns on
 * failures, or `null` when the error is not an Axios error or the body does not
 * match the {@link ServerError} shape.
 */
export function extractServerError(error: unknown): ServerError | null {
  if (!axios.isAxiosError(error)) return null;
  const data = error.response?.data as unknown;
  if (
    typeof data === "object" &&
    data !== null &&
    typeof (data as ServerError).call === "string" &&
    typeof (data as ServerError).message === "string"
  ) {
    return data as ServerError;
  }
  return null;
}

/** Returns the HTTP status of an Axios error, or `undefined` for other errors. */
export function getResponseStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}
